import { getRefreshableItemsFromScopes } from '../../authorize/urlParams';
import { CommonError } from '../../stores/app-state-errors';
import { ERR_PARAM_AUTHORIZATION_CODE_INVALID } from '../../utilities/error';
import { ValidateProductParams } from '../../utilities/urlParameters';

export const validateParams: ValidateProductParams = (commonParameters) => {
  const errors: CommonError[] = [];

  const { authorizationCode, handoffSessionId, authorizationToken } = commonParameters;

  if (!authorizationCode && !handoffSessionId && !authorizationToken) {
    errors.push(ERR_PARAM_AUTHORIZATION_CODE_INVALID);
  }

  return {
    parameters: { refreshableItems: getRefreshableItemsFromScopes(commonParameters.scope || '') },
    errors,
  };
};
